<template>
  <div
    class="mainLayout mainLayout_fullWidth"
    :class="{
      'mainLayout_fit-height': shouldFitHeight,
    }"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: 'MainLayout',
  data: () => ({
    snackbar: false,
    snackText: '',
  }),
  computed: {
    routeName() {
      return this.$route.name;
    },
    shouldFitHeight() {
      return !(this.routeName || '').startsWith('help');
    },
  },
  watch: {
    snack(val) {
      this.snackText = val[val.length - 1];
      this.snackbar = true;
    },
  },
};
</script>

<style lang="scss">
.mainLayout {
  display: flex;
  overflow: hidden;
  flex: 1;
  position: relative;
  padding: 20px 90px 20px;
  &_fit-height {
    max-height: 100vh;
  }
  &_fullWidth {
    > * {
      width: 100%;
    }
  }
}
</style>
